import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const DEFAULT_TITLE = "Aaron DPenha | The App Fam - AI Apps for Everyday Life";
const DEFAULT_DESCRIPTION =
  "Official website of Aaron DPenha. Explore The App Fam's AI-powered apps for productivity, family life, growth, and learning.";

const routeSeo = {
  "/": {
    title: DEFAULT_TITLE,
    description: DEFAULT_DESCRIPTION,
  },
  "/about": {
    title: "About Aaron DPenha | The App Fam",
    description:
      "Learn about Aaron DPenha, founder of The App Fam, and the mission behind practical AI-powered apps.",
  },
  "/apps": {
    title: "Apps by Aaron DPenha | The App Fam",
    description:
      "Discover AI-powered apps built by Aaron DPenha to improve productivity, learning, and everyday life.",
  },
  "/contact": {
    title: "Contact Aaron DPenha | The App Fam",
    description:
      "Contact Aaron DPenha at The App Fam for partnerships, questions, or support related to our apps.",
  },
  "/joshai": {
    title: "Hey Josh | The App Fam",
    description:
      "Meet Hey Josh, The App Fam's AI assistant for everyday tasks like paying bills, planning travel, managing reminders, and more.",
  },
  "/josh": {
    title: "Hey Josh | The App Fam",
    description:
      "Meet Hey Josh, The App Fam's AI assistant for everyday tasks like paying bills, planning travel, managing reminders, and more.",
  },
  "/scribemind": {
    title: "ScribeMind | The App Fam",
    description:
      "ScribeMind turns lectures, meetings, and ideas into smart notes, summaries, and quizzes so you can learn faster.",
  },
  "/selahdaily": {
    title: "Selah Daily | The App Fam",
    description:
      "Selah Daily turns sermons into devotionals, prayer prompts, and daily spiritual rhythms that help believers grow throughout the week.",
  },
  "/privacy": {
    title: "Privacy Policy | The App Fam",
    description: "Read The App Fam's privacy policy and data handling practices.",
  },
  "/privacy/josh": {
    title: "Hey Josh Privacy Policy | The App Fam",
    description: "Privacy policy for Hey Josh by The App Fam.",
  },
  "/privacy/selah-daily": {
    title: "Selah Daily Privacy Policy | The App Fam",
    description: "Privacy policy for Selah Daily by The App Fam.",
  },
  "/privacy/scribemind": {
    title: "ScribeMind Privacy Policy | The App Fam",
    description: "Privacy policy for ScribeMind by The App Fam.",
  },
  "/terms": {
    title: "Terms of Service | The App Fam",
    description: "Terms of service for using The App Fam websites and applications.",
  },
  "/terms/josh": {
    title: "Hey Josh Terms & Conditions | The App Fam",
    description: "Terms and conditions for Hey Josh by The App Fam.",
  },
};

const setMetaContent = (name, content, isProperty = false) => {
  const selector = isProperty
    ? `meta[property="${name}"]`
    : `meta[name="${name}"]`;
  const el = document.head.querySelector(selector);
  if (el) el.setAttribute("content", content);
};

const SEOManager = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    const page = routeSeo[pathname] || routeSeo["/"];
    const origin = window.location.origin;
    const canonicalUrl = `${origin}${pathname}`;

    document.title = page.title;
    setMetaContent("description", page.description);
    setMetaContent("og:title", page.title, true);
    setMetaContent("og:description", page.description, true);
    setMetaContent("og:url", canonicalUrl, true);
    setMetaContent("twitter:title", page.title);
    setMetaContent("twitter:description", page.description);

    const canonical = document.getElementById("canonical-link");
    if (canonical) {
      canonical.setAttribute("href", canonicalUrl);
    }
  }, [pathname]);

  return null;
};

export default SEOManager;
